/**
 * @file header-brand-modes.ts
 * @description Варианты бренда в шапке (phase19.16 Р1; SB90, SB21): подпись
 * и чего варианту не хватает. Общие для списка `BrandModeList` и сводки
 * группы «Бренд в шапке» (SB122).
 */

import type { SiteHeaderBrandMode } from "@chaiberi/shared";

/** Подпись варианта и чего ему не хватает. Ключи — все варианты SITE_HEADER_BRAND_MODES. */
export const BRAND_MODE_META: Readonly<Record<SiteHeaderBrandMode, { label: string; needs: Array<"logo" | "tagline"> }>> = {
  "logo+name+tagline": { label: "Логотип + название + слоган", needs: ["tagline"] },
  "logo+name": { label: "Логотип + название", needs: [] },
  logo: { label: "Только логотип", needs: ["logo"] },
  name: { label: "Только название", needs: [] },
};

/** Подпись варианта — для сводки группы. */
export function brandModeLabel(mode: SiteHeaderBrandMode): string {
  return BRAND_MODE_META[mode].label;
}
